import {
  FieldAnswer,
  FieldOption,
  Patient,
  RefAnswer,
  Reference,
} from "@/src/data/allTypes";
import { getItemId, uid } from "@/src/utils/utils";
import { shouldShowField } from "../documents/documentConditions";
import moment from "moment";

export function FieldAnswersList({
  reference,
  patient,
  answers,
}: {
  reference: Reference | null | undefined;
  patient: Patient | null | undefined;
  answers: (FieldAnswer | null | undefined)[] | null | undefined;
}) {
  function getValue(
    value: any,
    options: (FieldOption | null | undefined)[]
  ): any {
    if (Array.isArray(value)) return value.map((v) => getValue(v, options));
    let val = value?.id || value;
    let option = options?.find((option) => option?.id === val);

    let name = option?.name || val;
    if (name == "true") return "oui";
    if (name == "false") return "non";
    return name;
  }

  function getOptionNumber(val: any) {
    if (!val) return val;
    if (!val.includes("options:")) return val;
    let option = val.split(":")[1];
    try {
      return atob(option.replaceAll("_", "="));
    } catch (e) {
      return val;
    }
  }

  return (
    <div className="c1 gap10">
      {answers?.map((fieldAnswer) => {
        let field = fieldAnswer?.field;
        let val = getValue(fieldAnswer?.value, field?.options || []);

        if (
          !shouldShowField({
            field,
            fieldAnswers: answers,
            patient,
            reference,
          })
        )
          return null;

        if (val == "options:T3Vp") val = "Oui";
        if (val == "options:Tm9u") val = "Non";
        val = getOptionNumber(val);

        return (
          <div key={uid()} className=" c2 gap5 acenter">
            <div className="gray">{field?.name}</div>
            <div className="bold right">
              {`${val}`} {field?.unit?.name}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function generateAnswersString(
  refAnswer: RefAnswer | null | undefined,
  reference: Reference | null | undefined
) {
  let str = "";
  let fieldAnswers = refAnswer?.fieldAnswers || [];
  let sections = reference?.sections || [];
  str += `<strong>${reference?.name || ""} du ${
    moment(refAnswer?._date).format("LL") || ""
  }</strong>\n\n`;
  for (let section of sections) {
    let localhtml = "";
    for (let field of section?.fields || []) {
      let fieldAnswer = fieldAnswers.find(
        (fieldAnswer) => getItemId(fieldAnswer?.field) == getItemId(field)
      );
      if (!fieldAnswer) continue;
      localhtml += `
     
      - ${field?.name}: ${getValueStr(fieldAnswer.value, field?.options || [])}
      
      `;
    }
    if (!localhtml) continue;
    localhtml = `
    <strong>${section?.name || ""}</strong>
    
    ${localhtml}

    `;

    str += localhtml;
  }
  if (refAnswer?.notes) str += `\n\n${refAnswer?.notes}`;
  if (refAnswer?.conclusion) str += `\n\n${refAnswer?.conclusion}`;

  return str;
}

function getValueStr(
  value: any,
  options: (FieldOption | null | undefined)[]
): any {
  if (Array.isArray(value)) return value.map((v) => getValueStr(v, options));
  let val = value?.id || value;
  let option = options?.find((option) => option?.id === val);

  let name = option?.name || val;
  if (name == "true") return "oui";
  if (name == "false") return "non";
  return name;
}
